import { connect } from 'react-redux';
import { compose, hoistStatics, lifecycle, withState, withHandlers, defaultProps, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import Profile from './Profile';
import fh from '../../helpers/form.helper';
import ProfileService from '../../services/profile.service';
import WithLoading from '../../components/WithLoading';
import { uploadSelectors, uploadActions } from '../../reducers/upload';
import { userActions } from '../../reducers/user';
import UserService from '../../services/user.service';
import { settingsActions } from '../../reducers/settings';

const imageSelector = uploadSelectors.getTempFile('avatar');

const mapStateToProps = state => ({
  avatar: imageSelector(state),
  backgroundColor: state.settings.subscriber.color,
  langs: state.settings.langs.map(lang => ({ label: lang.title, value: lang.name })),
});

const mapDispatchToProps = {
  removeTempFile: uploadActions.removeTempFile,
  setUser: userActions.setUser,
  updateSettings: settingsActions.updateSettings,
};

const onSubmit = props => async (event) => {
  const { avatar, formData, history, setErrors, checked, t } = props;
  event.preventDefault();
  props.setIsSubmitting(true);
  const emailPermissions = [];
  Object.keys(checked).forEach((type) => {
    emailPermissions.push({ status: checked[type], type: parseInt(type, 10) });
  });
  const { user, errors } = await ProfileService.update({
    ...formData,
    emailPermissions,
    avatar: avatar && avatar.id ? avatar.id : '',
  });
  props.setIsSubmitting(false);
  if (errors) {
    setErrors(errors);
  } else {
    toast.success(t('Your changes saved!'));
    // props.removeTempFile('avatar');
    props.setUser({ user });
    history.goBack();
  }
};

const updateChecked = props => (index, value) => {
  props.setChecked({ ...props.checked, [index]: value });
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('isSubmitting', 'setIsSubmitting', false),
  withState('errors', 'setErrors', {}),
  withState('emailTokens', 'setEmailTokens', props => (UserService.getEmailTokens(props.t))),
  withState('checked', 'setChecked', {}),
  withState('formData', 'setFormData', {
    avatar: {
      filename: '',
    },
  }),
  defaultProps({
    getAvatar: UserService.getAvatar,
  }),
  withProps(props => ({
    avatarSrc: props.avatar && props.avatar.url
      ? props.avatar.url : UserService.getAvatar(props.formData, 300, 300),
  })),
  lifecycle({
    async componentDidMount() {
      const { setChecked, setFormData, setIsLoading, updateSettings } = this.props;
      updateSettings({ hasLoadedPage: false });
      const user = await ProfileService.get();
      await setFormData(user);
      const checked = {};
      user.emailPermissions.forEach((token) => {
        checked[token.type] = token.status;
      });
      setChecked(checked);
      updateSettings({ hasLoadedPage: true });
      setIsLoading(false);
    },
  }),
  withHandlers({
    onChange: fh.onChangeFormDataElement,
    onSubmit,
    updateChecked,
    goBack: props => () => props.history.goBack(),
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Profile)));



// WEBPACK FOOTER //
// ./src/views/profile/index.js